import { SankeyLink } from '../types/sankey';

export const RTC4: SankeyLink[] = [
    {
        source: 114,
        target: 16,
        value: 1,
        valueid: 'repf',
        paperName: 'KSBK15',
        process: 'KSBK15_7',
        id: 'KSBK15-30',
        cluster: 'rtc4',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 16, target: 46, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_7', id: 'KSBK15-78', cluster: 'rtc4', imgUrl: 'AY0EaHs.png', color: 'intFiveLinkColor' },
    { source: 46, target: 60, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_7', id: 'KSBK15-84', cluster: 'rtc4', imgUrl: 'AY0EaHs.png', color: 'intFiveLinkColor' },
    { source: 60, target: 89, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_7', id: 'KSBK15-98', cluster: 'rtc4', imgUrl: 'AY0EaHs.png', color: 'repVisTechColor' },
    {
        source: 157,
        target: 5,
        value: 1,
        valueid: ['targetaa', 'repb'],
        paperName: 'SFJ16',
        process: 'SFJ16_1',
        id: 'SFJ16-0',
        cluster: 'rtc4',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 157,
        target: 11,
        value: 1,
        valueid: ['targetaa', 'repb'],
        paperName: 'SFJ16',
        process: 'SFJ16_1',
        id: 'SFJ16-1',
        cluster: 'rtc4',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 157,
        target: 12,
        value: 1,
        valueid: ['targetaa', 'repb'],
        paperName: 'SFJ16',
        process: 'SFJ16_1',
        id: 'SFJ16-2',
        cluster: 'rtc4',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 157,
        target: 22,
        value: 1,
        valueid: ['targetaa', 'repb'],
        paperName: 'SFJ16',
        process: 'SFJ16_1',
        id: 'SFJ16-3',
        cluster: 'rtc4',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    { source: 5, target: 40, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_1', id: 'SFJ16-9', cluster: 'rtc4', imgUrl: 'e3PRKTM.jpg', color: 'intTwoLightLinkColor' },
    { source: 11, target: 40, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_1', id: 'SFJ16-10', cluster: 'rtc4', imgUrl: 'e3PRKTM.jpg', color: 'intTwoLightLinkColor' },
    { source: 12, target: 40, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_1', id: 'SFJ16-11', cluster: 'rtc4', imgUrl: 'e3PRKTM.jpg', color: 'intTwoLightLinkColor' },
    { source: 22, target: 40, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_1', id: 'SFJ16-12', cluster: 'rtc4', imgUrl: 'e3PRKTM.jpg', color: 'intTwoLightLinkColor' },
    { source: 40, target: 54, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_1', id: 'SFJ16-13', cluster: 'rtc4', imgUrl: 'e3PRKTM.jpg', color: 'intTwoLightLinkColor' },
    { source: 54, target: 89, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_1', id: 'SFJ16-14', cluster: 'rtc4', imgUrl: 'e3PRKTM.jpg', color: 'repVisTechColor' },
    {
        source: 135,
        target: 16,
        value: 1,
        valueid: ['repf', 'targetbb'],
        paperName: 'YFS10',
        process: 'YFS10_3',
        id: 'YFS10-16',
        cluster: 'rtc4',
        imgUrl: 'A14dGOk.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 16, target: 45, value: 1, valueid: ['repf', 'targetbb'], paperName: 'YFS10', process: 'YFS10_3', id: 'YFS10-17', cluster: 'rtc4', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { source: 45, target: 60, value: 1, valueid: ['repf', 'targetbb'], paperName: 'YFS10', process: 'YFS10_3', id: 'YFS10-18', cluster: 'rtc4', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { source: 60, target: 94, value: 1, valueid: ['repf', 'targetbb'], paperName: 'YFS10', process: 'YFS10_3', id: 'YFS10-21', cluster: 'rtc4', imgUrl: 'A14dGOk.png', color: 'repVisTechColor' },
    {
        source: 143,
        target: 19,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_3',
        id: 'RRR19-6',
        cluster: 'rtc4',
        imgUrl: 'yya8s2u.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 19, target: 43, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_3', id: 'RRR19-23', cluster: 'rtc4', imgUrl: 'yya8s2u.png', color: 'intThreeLight1LinkColor' },
    { source: 43, target: 61, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_3', id: 'RRR19-24', cluster: 'rtc4', imgUrl: 'yya8s2u.png', color: 'intThreeLight1LinkColor' },
    { source: 61, target: 94, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_3', id: 'RRR19-26', cluster: 'rtc4', imgUrl: 'yya8s2u.png', color: 'repVisTechColor' },
    {
        source: 101,
        target: 15,
        value: 1,
        valueid: ['repb', 'targetbb'],
        paperName: 'CGK21',
        process: 'CGK21_4',
        id: 'CGK21-5',
        cluster: 'rtc4',
        imgUrl: 'Q201xEJ.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 101,
        target: 16,
        value: 1,
        valueid: ['repb', 'targetbb'],
        paperName: 'CGK21',
        process: 'CGK21_6',
        id: 'CGK21-7',
        cluster: 'rtc4',
        imgUrl: 'Q201xEJ.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 15, target: 41, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_4', id: 'CGK21-15', cluster: 'rtc4', imgUrl: 'Q201xEJ.jpg', color: 'intThreeLinkColor' },
    { source: 16, target: 41, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_6', id: 'CGK21-17', cluster: 'rtc4', imgUrl: 'Q201xEJ.jpg', color: 'intThreeLinkColor' },
    { source: 41, target: 54, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_4', id: 'CGK21-23', cluster: 'rtc4', imgUrl: 'Q201xEJ.jpg', color: 'intThreeLinkColor' },
    { source: 41, target: 54, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_6', id: 'CGK21-24', cluster: 'rtc4', imgUrl: 'Q201xEJ.jpg', color: 'intThreeLinkColor' },
    { source: 54, target: 87, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_4', id: 'CGK21-43', cluster: 'rtc4', imgUrl: 'Q201xEJ.jpg', color: 'repVisTechColor' },
    { source: 54, target: 87, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_6', id: 'CGK21-44', cluster: 'rtc4', imgUrl: 'Q201xEJ.jpg', color: 'repVisTechColor' },
];
